import React, { useMemo } from 'react'
import { withStyles } from '@material-ui/core/styles'
import styles from './styles'
import WidgetForm from '../WidgetForm'
import CodeView from '../CodeView'

const ModalWidget = props => {
  const { classes, config, onConfigChange } = props

  return (
    <div className={classes.root}>
      <WidgetForm
        config={config}
        onConfigChange={onConfigChange}
        showPosition={false}
      />
      <CodeView
        label="HTML"
        buttonLabel="Copy HTML code"
        widgetType="modal"
        config={config}
      />
      <CodeView
        label="JavaScript"
        buttonLabel="Copy JavaScript code"
        widgetType="modal"
        config={config}
      />
    </div>
  )
}

export default withStyles(styles)(ModalWidget)
